import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createLitter, type Litter } from '@/api/entities/litters';
import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';
import { useCognitoAuth } from '@/hooks/useCognitoAuth';
import { GraphQLRequestError } from '@/api/graphql';

type QueryFnType = typeof createLitter;

type UseCreateLitterOptions = {
  config?: MutationConfig<QueryFnType>;
};

export const useCreateLitter = ({ config }: UseCreateLitterOptions = {}) => {
  const queryClient = useQueryClient();
  const { getAccessToken } = useCognitoAuth();

  return useMutation<ExtractFnReturnType<QueryFnType>, GraphQLRequestError, Partial<Litter>>({
    ...config,
    mutationFn: async (input: Partial<Litter>) => {
      return createLitter(input, getAccessToken);
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({ queryKey: ['litters'] });
      config?.onSuccess?.(data, variables, onMutateResult, context);
    },
  });
};
